import { render, staticRenderFns } from "./WebPartVideo.vue?vue&type=template&id=3749fbeb&"
import script from "./WebPartVideo.vue?vue&type=script&lang=js&"
export * from "./WebPartVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3749fbeb')) {
      api.createRecord('3749fbeb', component.options)
    } else {
      api.reload('3749fbeb', component.options)
    }
    module.hot.accept("./WebPartVideo.vue?vue&type=template&id=3749fbeb&", function () {
      api.rerender('3749fbeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartVideo.vue"
export default component.exports